import styled, { css } from 'styled-components';
import colors from '@designSystem/colors';
import { StyledLinkParagraph, StyledParagraph } from '../desktop/styles';
import { Header } from '@designSystem/typings';

export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  padding: 24px;
  background-color: ${colors.white};
  border-radius: 10px;
`;

export const WrapperCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  div:last-child {
    margin-top: 16px;
  }
`;

const cardText = css`
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 400;
`;

export const CardParagraph = styled(StyledParagraph)`
  ${cardText}
  color: ${colors.black};
`;

export const CardLinkParagraph = styled(StyledLinkParagraph)`
  ${cardText}
`;

export const WrapHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

export const StyledHeader = styled(Header)`
  line-height: 40px;
`;
